import articleWispehone from "./work-articles/articleWisephone";
import articleBulletins from "./work-articles/articleBulletins";
import articleAnimationShowcase from "./work-articles/articleAnimationShowcase";
import articleKirkElliott from "./work-articles/articleKirkElliott";

const work_featured = [
  articleKirkElliott,
  articleWispehone,
  articleBulletins,
  articleAnimationShowcase
]
export default work_featured;